import type { TypographyProps } from '@elfsight/widget-ui';
import { Author } from '../Author';
import { CaptionLoader } from './CaptionLoader';

interface CaptionProps {
  textStyle: TypographyProps['textStyle'];
  isLoading: boolean;
  disableTicker: boolean;
  caption?: string;
}

export function Caption({
  caption,
  textStyle,
  disableTicker,
  isLoading
}: CaptionProps) {
  const { lineHeight } = textStyle ?? {};
  const loaderHeight =
    typeof lineHeight === 'number' ? lineHeight : parseInt(lineHeight ?? '16');

  if (isLoading) {
    return <CaptionLoader height={loaderHeight} />;
  }

  return (
    <Author textStyle={textStyle} disableTicker={disableTicker}>
      {caption}
    </Author>
  );
}
